var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('app-shell',[_c('vnt-header',[_vm._v("Add category")]),_c('category-form')],1)}
var staticRenderFns = []

export { render, staticRenderFns }